import React from "react";
import Skeleton from "@mui/material/Skeleton";
import image from "../assets/Thumbnail_default.jpg";
const LazyImage = ({
  width = "100%",
  borderRadius = 8,
  aspectRatio = "16/9",
  height,
  url,
}) => {
  const [loaded, setLoaded] = React.useState(false);

  return (
    <div
      style={{
        width,
        aspectRatio,
        position: "relative",
        borderRadius,
        overflow: "hidden",
        ...(height ? { height } : {}), // ❗ Don't force auto height
      }}
      data-testid="lazy-image"
    >
      {/* Skeleton should show when NOT loaded */}
      {!loaded && (
        <Skeleton
          data-testid="skeleton-loader"
          variant="rectangular"
          width="100%"
          height="100%"
          style={{
            position: "absolute",
            inset: 0,
            borderRadius,
          }}
        />
      )}

      {/* Image */}
      <img
        src={url || image}
        alt="Thumbnail"
        onLoad={() => setLoaded(true)}
        style={{
          width: "100%",
          height: "100%",
          // objectFit: "cover",
          objectPosition: "center",
          opacity: loaded ? 1 : 0,
          transition: "opacity 0.3s ease-in-out",
          position: "absolute",
          inset: 0,
          borderRadius,
        }}
      />
    </div>
  );
};

export default LazyImage;
